import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Partner } from '@app/entity';
import { API_VERSION } from '@app/core/api.version';

@Injectable()
export class PartnersService {

  constructor(private http: HttpClient) { }

  getPartner(id: number): Observable<Partner> {
    return this.http.get<Partner>(`/${API_VERSION}/partners/${id}/`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/partners.service.ts